export const randColor = () => `hsl(${Math.round(Math.random() * 360)}, 70%, 50%)`
